import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { ToasterService } from '@shared/services/toaster.service';
import { BaseResponse } from '@core/interfaces/base-response.interface';
import { AuthService } from '@core/services';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const toasterMessage = inject(ToasterService);
  const authService = inject(AuthService);

  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const responseBody = event.body as BaseResponse<object>;
        if (
          responseBody?.status == 200 &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== ''
        ) {
          toasterMessage.showSuccess(responseBody.message);
        } else if (
          responseBody.status !== 200 &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== '' &&
          responseBody.status !== 500
        ) {
          toasterMessage.showErrorMessage(responseBody.message);
        } else if (responseBody.status === 500) {
          throw new Error('Internal server error');
        }
      }
      return event;
    }),
    catchError(error => {
      let errorMessage = error.error ? error.error.message : error.message;
      if (error.status === 500) {
        errorMessage = 'Internal server error';
      }
      if (error.status === 401) {
        authService.logout();
      }
      toasterMessage.showErrorMessage(errorMessage);

      throw error;
    })
  );
};
